import(/* webpackMode: "eager" */ "/vercel/path0/app/(frontend)/[...slug]/error.tsx");
